class ElectronicBillingHTTP {
    checkStatus(response) {
        switch (response.status) {
            case 500:
                throw new Error(`${response.status} - Server Error!`);
            case 403:
                throw new Error(`${response.status} - Unhautorized!`);
            default:
                break;
        }
    }

    async getProviders() {
        let providers = [];
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}factura-electronica/listar-proveedores`, {
            method: 'GET',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            'Content-Type': 'application/json'
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        }).then(data => {
            providers = data;
        }).catch((error) => {
            providers = [];
        });
        return providers;
    }

    async getActualProvider() {
        let proveedor = { id_factura_electronica_api: null, proveedor: null }
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}factura-electronica/consultar-proveedor-actual?id_clinica=${sessionStorage.getItem('id_clinica')}`, {
            method: 'GET',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            'Content-Type': 'application/json'
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        }).then(data => {
           proveedor = data;
        }).catch((error) => {
            proveedor = { id_factura_electronica_api: null, proveedor: null };
        });
        return proveedor;
    }

    async updateProvider(id_factura_electronica_api,resolucion_fe,usuario_fe,password_fe,url_fe) {
        let actualProvider = id_factura_electronica_api;
        let sendData =
        {
            id_factura_electronica_api: id_factura_electronica_api,
            id_clinica: sessionStorage.getItem('id_clinica'),
            resolucion_fe:resolucion_fe,
            usuario_fe:usuario_fe,
            password_fe: password_fe,
            url_endpoint:url_fe
        }
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}factura-electronica/actualizar-proveedor`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(sendData)
        }).then(response => {
            this.checkStatus(response);
        }).catch((error) => {
            actualProvider = null;
            throw new Error(error);
        });
        return actualProvider;
    }

    async saveCUFE(cufe, id_factura) {
        let sendData =
        {
            id_factura_t: id_factura,
            cufe: cufe
        }
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}facturas/save-cufe`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(sendData)
        }).then(response => {
            this.checkStatus(response);
        }).catch((error) => {
            console.log(error);
        });
    }
}

export default new ElectronicBillingHTTP();